const FormLabels = {
    init(form) {
        this.texts = form.find('input[type="text"], input[type="password"], input[type="number"], input[type="email"], input[type="tel"], input[type="url"], textarea');
        this.inputs = form.find('select, input[type="number"], input[type="checkbox"], input[type="radio"]');
        this.inputs.each((i, el) => {
            this.bindInputs($(el));
        })

        this.texts.each((i, el) => {
            this.bindTexts($(el));
        })
    },

    bindInputs(input) {
        input.change((evt) => {
            this.set($(evt.currentTarget));
        });

        this.set(input);
    },

    bindTexts(input) {
        input.keydown((evt) => {

        });

        input.on('keyup', (evt) => {
            this.set($(evt.currentTarget));
        })

        setTimeout(() => {
            this.set(input);
        }, 100)

    },

    set(input) {
        const type = input.is('select') ? 'select' : input.attr('type');
        const value = input.val();
        const item = input.closest('.input');

        item.removeClass('filled');

        if (
            type === "checkbox" || type === "radio"
            || (type === "number" || type === "select") && value
            || (type === "text" || type === "password" || type === "email" || type === "tel" || input.is('textarea')) && value.length > 0
        ) {
            item.addClass('filled');
        }
    },
}

export default FormLabels;

